import { useElementContext } from '@ten24/slatwall-storefront-react-private/global'
import { PageContentRow } from '../../components/PageContentRow/PageContentRow'
import { useContentContext } from '../../contexts/ContentContext'

import DynamicPage from '../DynamicPage/DynamicPage'

const Shop = () => {
  const { SearchListingStack } = useElementContext()
  const pageData = useContentContext()

  const { searchListing } = pageData.templateData || {}
  if(!searchListing) return <DynamicPage />

  return (
    <DynamicPage>
      {({ renderDynamicContent }) => (
        <>
          <PageContentRow>
            <SearchListingStack {...searchListing} />
          </PageContentRow>
          {renderDynamicContent()}
        </>
      )}
    </DynamicPage>
  )
}

export default Shop
